export default __webpack_public_path__ + "static/fire_pump_w.48aef3afa5b229a57e628ee52a00b78c.svg";